export default (clientHttp, apiVersion) => ({
  /**
   *
   * @returns {Promise<{ data: { content: string; id: string; type: string }}>}
   */
  read() {
    return clientHttp.get(`${apiVersion}/client_general_rental_condition`)
  },
})
